import { TopList } from "../templates/fragments/top-list";
import { SearchLabels } from "../components/search/inputs/texts/labels";
import { search } from "./weatherSearch";

export const getFormValuesForTopList = (
    topListJson: TopList
): SearchFormInputs => {
    let activity = topListJson.additionalData.activity;
    const activitySplitted = activity.split(".");
    if (activitySplitted.length > 1) {
        activity = activitySplitted[1];
    }
    const constraints = topListJson.additionalData.constraints;
    let activityPrefix = undefined;
    const pricesObject: { flightOrigin: SearchFlightOrigin } = {
        flightOrigin: "easternUs"
    };
    const othersObject: { visaOrigin: SearchVisaOrigin } = {
        visaOrigin: "usa"
    };
    for (const key in SearchLabels) {
        if (key.includes(activity)) {
            activityPrefix = key.includes(".") ? key.split(".")[0] : undefined;
            break;
        }
    }
    let activityObject;
    if (activity === "beaches") {
        activityObject = { focus: "beach" };
    } else {
        activityObject = activityPrefix
            ? { [activityPrefix]: { [activity]: true } }
            : { [activity]: true };
        if (activityPrefix === "other") {
            othersObject[activity] = true;
        }
    }
    for (let constraint of constraints) {
        if (constraint.constraint === "month") {
            if (constraint.constraintNumber) {
                activityObject["month"] = constraint.constraintNumber;
            }
            if (constraint.constraintArray) {
                let month;
                switch (constraint.constraintArray[0]) {
                    case 12:
                        month = "winter";
                        break;
                    case 3:
                        month = "spring";
                        break;
                    case 6:
                        month = "summer";
                        break;
                    case 9:
                        month = "autumn";
                        break;
                }
                activityObject["month"] = month;
            }
        }
        if (constraint.constraint === "continent") {
            activityObject["continent"] = constraint.constraintString;
        }
        if (constraint.constraint === "additional") {
            if (constraint.constraintString === "budget") {
                pricesObject["pricesOverall"] = 1;
            } else {
                activityObject["suitability"] = constraint.constraintString;
            }
        }
    }
    return {
        ...activityObject,
        prices: pricesObject,
        other: othersObject
    };
};
